import wrapper from 'wrapper';
import ResizePlugin from '@bbc/news-vj-search-lookup-plugin-resize';
import SearchLookupOverride from './search-lookup-override';
import CustomPostcodePlugin from './customPostcodePlugin';
import ResultsHandler from '../results/results';

const errorNoResults = __('invalid-postcode');

export default class Lookup {
    constructor(data) {
        this.renderLookup(data);
        this.inputValue = '';
        this.resultsHandler = new ResultsHandler();
    }

    renderLookup(trustData) {
        new SearchLookupOverride({
            target: wrapper.select('#lookup-container'),
            data: trustData,
            clearInput: true,
            confirmOnBlur: false,
            useSuggestions: true,
            displayKey: 'name',
            minChars: 2,
            vocab: {
                noResults: errorNoResults,
            },
            overrideResults: (query, data) => [...new Map(data.map((d) => [d.id, d])).values()], // removes duplicate responses from locator (issue for NI)
            onSelect: (id, data) => {
                this.ATI(data);
                this.loadContent(data);
                wrapper.select('.methodology__container').classList.remove('hidden');
            },
            plugins: [
                new ResizePlugin({
                    container: wrapper.select('.bbc-news-vj-wrapper'),
                }),
                new CustomPostcodePlugin({
                    searchType: (postcode) => 'nhs-trust,gss-health', // eslint-disable-line
                    intersectCallback: () => false,
                }),
            ],
        });
    }

    loadContent(data) {
        this.resultsHandler.init(data, data.nation);
    }

    ATI() {
        wrapper.trackClick('Trust selected');
    }
}
